import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import HomeVersionB from './pages/HomeVersionB';
import Offers from './pages/Offers';
import Contact from './pages/Contact';
import GarageEpoxy from './pages/GarageEpoxy';
import AboutUs from './pages/AboutUs';
import WarehouseEpoxy from './pages/WarehouseEpoxy';
import WorkshopEpoxy from './pages/WorkshopEpoxy';
import CommercialEpoxy from './pages/CommercialEpoxy';
import DrivewayResurfacing from './pages/DrivewayResurfacing';
import MetallicEpoxy from './pages/MetallicEpoxy';
import FlakeFlooring from './pages/FlakeFlooring';
import ShopsShowroomsEpoxy from './pages/ShopsShowroomsEpoxy';
import OfficeEpoxy from './pages/OfficeEpoxy';
import EpoxyFlooringSydney from './pages/EpoxyFlooringSydney';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Offers />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/home-2" element={<HomeVersionB />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/garage-epoxy" element={<GarageEpoxy />} />
          <Route path="/warehouse-epoxy" element={<WarehouseEpoxy />} />
          <Route path="/workshop-epoxy" element={<WorkshopEpoxy />} />
          <Route path="/commercial-epoxy" element={<CommercialEpoxy />} />
          <Route path="/driveway-resurfacing" element={<DrivewayResurfacing />} />
          <Route path="/metallic-epoxy" element={<MetallicEpoxy />} />
          <Route path="/flake-flooring" element={<FlakeFlooring />} />
          <Route path="/shops-showrooms-epoxy" element={<ShopsShowroomsEpoxy />} />
          <Route path="/office-epoxy" element={<OfficeEpoxy />} />
          <Route path="/epoxy-flooring-sydney" element={<EpoxyFlooringSydney />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
